<template>
    <div class="px-6 surface-overlay relative">

        <ul class="list-none p-2 m-0 surface-card flex align-items-left font-medium overflow-x-auto">
            <li class="pr-3">
                <span class="text-900 line-height-3">{{ this.userStore.companyName }}</span>
            </li>
            <li class="px-1">
                <i class="pi pi-angle-double-right text-900 line-height-3"></i>
            </li>
            <li class="px-1">
                <span class="text-teal-500 line-height-3">{{ this.userStore.username }}</span>
            </li>
        </ul>

        <ul class="list-none p-2 m-0 surface-card flex align-items-left font-medium overflow-x-auto">
            <li v-if="(this.userStore.user.roles.includes('ROLE_ISOPRACTICE', 0))" class="px-1">
                <a @click="processOverview" class="cursor-pointer text-900 white-space-nowrap">PM Module</a>
            </li>
            <li v-if="(this.userStore.user.roles.includes('ROLE_ISOEVOLVE', 0))" class="px-1">
                <a @click="processOverview" class="cursor-pointer text-900 white-space-nowrap">MS Module</a>
            </li>
            <li v-if="(this.userStore.user.roles.includes('ROLE_ISOLEARN', 0))" class="px-1">
                <a @click="processOverview" class="cursor-pointer text-900 white-space-nowrap">SB Module</a>
            </li>
            <li v-if="(this.userStore.user.roles.includes('ROLE_ISORISE', 0))" class="px-1">
                <a @click="processOverview" class="cursor-pointer text-900 white-space-nowrap">FA Module</a>
            </li>
            <li v-if="(this.userStore.user.roles.includes('ROLE_USER', 0))" class="px-1">
                <a @click="processOverview" class="cursor-pointer text-900 white-space-nowrap">User Module</a>
            </li>
            <li v-if="(this.userStore.user.roles.includes('ROLE_ISOWEB', 0))" class="px-1">
                <a @click="processOverview" class="cursor-pointer text-900 white-space-nowrap">Simply Investing</a>
            </li>

            <li class="px-1">
                <i class="pi pi-angle-right text-900"></i>
            </li>
            <li class="px-1">
                <a @click="processOverview" class="cursor-pointer text-900 white-space-nowrap">Overview</a>
            </li>
            <li class="px-1">
                <i class="pi pi-angle-right text-900"></i>
            </li>
            <li class="px-1">
                <a @click="processOverviewQualification" class="cursor-pointer text-teal-500 white-space-nowrap">Qualification</a>
            </li>
        </ul>
    </div>
</template>

<script>
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";

export default {
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    mounted() {
        UserService.getUserPing()
            .then(data => {
                console.log("[HeadingPmModuleOverviewDashboard][mounted] System is active.");
                console.log("[HeadingPmModuleOverviewDashboard][mounted] Data = ", data);
            })
            .catch(e => {
                console.log("[HeadingPmModuleOverviewDashboard][mounted] System is NOT active.");
                console.log("[HeadingPmModuleOverviewDashboard][mounted] Error = ", e);

                this.userStore.clearUser;
                this.$router.push("login");
            });

        if (this.userStore.user === undefined) {
            console.log("[HeadingPmModuleOverviewDashboard][mounted] User is NOT defined.");

            this.userStore.clearUser;
            this.$router.push('login');
        } else {
            console.log("[HeadingPmModuleOverviewDashboard][mounted] User is defined. this.userStore.userId = ", this.userStore.userId);
        }
    },
    methods: {
        processOverview() {
            console.log("[HeadingApplications][processOverview] Beginning.");

            if (this.userStore.user.roles.includes("ROLE_ISOEVOLVE", 0)) {
                console.log("[Login][handleLogin] Processing role for ROLE_ISOEVOLVE");
                this.$router.push("msOverviewHome");
            } else if (this.userStore.user.roles.includes("ROLE_ISOPRACTICE", 0)) {
                console.log("[Login][handleLogin] Processing role for ROLE_ISOPRACTICE");
                this.$router.push("pmOverviewHome");
            } else if (this.userStore.user.roles.includes("ROLE_ISORISE", 0)) {
                console.log("[Login][handleLogin] Processing role for ROLE_ISORISE");
                this.$router.push("faOverviewHome");
            } else if (this.userStore.user.roles.includes("ROLE_ISOLEARN", 0)) {
                console.log("[Login][handleLogin] Processing role for ROLE_ISOLEARN");
                this.$router.push("sbOverviewHome");
            } else if (this.userStore.user.roles.includes("ROLE_ISOWEB", 0)) {
                console.log("[Login][handleLogin] Processing role for ROLE_ISOWEB");
                this.$router.push("siOverview");
            } else {
                console.log("[Login][handleLogin] Processing default role");
                this.$router.push("userOverview");
            }
        },
        processOverviewQualification() {
            this.$router.push("healthOverviewQualification");
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
